<template>
  <UserHeader :name="name" :username="username" :title="title" />
  <!-- <section class="view-indicator text-sm p-1">
    <button
      :class="calendarView ? 'active' : 'inactive'"
      @click="calendarView = true"
    >
      Calendar view
    </button>
    <button
      :class="!calendarView ? 'active' : 'inactive'"
      @click="calendarView = false"
    >
      List View
    </button>
  </section> -->
  <div class="select-location mt-2">
    <input type="radio" :value="true" v-model="calendarView" />
    <label>Lịch</label>
    <input type="radio" :value="false" v-model="calendarView" />
    <label>Bảng biểu</label>
  </div>
  <WeekViewEvents :username="username" v-if="calendarView" />
  <div v-else>
    <section class="view-indicator text-sm p-1">
      <button
        :class="upcoming ? 'active' : 'inactive'"
        @click="upcoming = true"
      >
        Termin sắp tới
      </button>
      <button
        :class="!upcoming ? 'active' : 'inactive'"
        @click="upcoming = false"
      >
        Termin cũ
      </button>
    </section>
    <UpcomingEvents v-if="upcoming" :username="username" />
    <PastEvents v-if="!upcoming" :username="username" />
  </div>
</template>

<script>
import useFirebaseAuth from "../hooks/firebase-auth";
import UserHeader from "../components/UserHeader";
import { useRoute, useRouter } from "vue-router";
// import useFetchData from "../hooks/fetch-data";
import UpcomingEvents from "../components/UpcomingEvents";
import PastEvents from "../components/PastEvents.vue";
import WeekViewEvents from "../components/WeekViewEvents.vue";
import { ref } from "vue";
export default {
  components: {
    UserHeader,
    UpcomingEvents,
    PastEvents,
    WeekViewEvents,
  },
  setup() {
    const { username, name } = useFirebaseAuth();
    const route = useRoute();
    const router = useRouter();
    const upcoming = ref(true);
    const calendarView = ref(false);
    if (username.value !== route.params.username) {
      router.push("/");
    }
    // const fetchData = useFetchData();

    // console.log("Username", username.value);

    // const upcomingEvents = await fetchData.getUpcomingEvents(username.value);
    // console.log("UPcoming events", upcomingEvents);
    // console.log("Dashboard", state.userData.username);
    // const username = state.username.value;
    // const { username } = useFirebaseAuth();
    const title = `Tư vấn hội nhập
Hội người Việt Nam tại Berlin và Brandenburg e.V.`;

    return { username, name, title, upcoming, calendarView };
  },
};
</script>

<style scoped lang="scss">
.view-indicator {
  margin: 0 auto;
  button {
    @apply py-1 px-4 my-2;
  }
  .inactive {
    @apply bg-white text-blue-900;
  }
  .active {
    @apply bg-blue-900 text-white;
  }
}
.select-location {
  input {
    margin: 0.6rem;
  }
  label {
    margin-right: 1rem;
  }
}
</style>
